import { AnimationBuilder, AnimationPlayer } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';
import { UserDataService, UserSessionService } from '@com-delta-idp/mnx-oauth';
import { IropService, LoggingService } from '@com-delta-idp/mnx-utils';
import {
  ErrorMessage,
  Tracker,
  TrackerCollapsedForStandardMocks
} from '@com-delta-omnichannel/aura';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CookieHelper } from '../../common/cookie-helper';
import { DataLayer } from '../../common/datalayer/datalayer';
import { ApplicationConfig } from '../../config/config';
import { TrackerStaticText } from '../../header/login/login.interface';
import { ContentMyDelta } from '../../model/content/contentmydelta.model';
import { ContentPrimaryNavigation } from '../../model/content/contentprimarynavigation.model';
import { ContentTodayPanel } from '../../model/content/contenttodaypanel.model';
import { TodaysTrip } from '../../model/today-trip.model';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { LogoutService } from '../../services/logout/logout.service';
import { TodaysTripAwsService } from '../../services/mydelta-trip-service/trip-aws.service';
import { TripService } from '../../services/mydelta-trip-service/trip.service';
import { ErrorMessagesReducerStoreService } from '../../store/services/error-message.reducer.service';

@Component({
  selector: 'ngc-flyout-loggedin',
  templateUrl: './flyout-loggedin.component.html'
})
export class FlyoutLoggedinComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  flyOutPositionHeight: any;
  accountSummaryServiceSubscribe: Subscription;
  iropServiceSubscribe: Subscription;
  enableTodayTab = true;
  enableVsTodayTab = false;
  member: any;
  public isDelta: boolean;
  public iropEnable: boolean;
  public feedCounterValue: any;
  public flyoutContent: ContentMyDelta;
  public flyoutTodayContent: ContentTodayPanel;
  public mytripHeaderContentLabel: ContentPrimaryNavigation;
  public bookingHeaderContentLabel: ContentPrimaryNavigation;
  public timeouts = [];
  public player: AnimationPlayer;
  public showNewToday: boolean;

  greetingMessage: any;
  memberTypeData: any;
  resAcctSumContent: any;
  isModalShown: boolean;
  staticTrackerAemContent: TrackerStaticText;
  showStaticTracker: boolean;
  upcomingTracker: boolean;

  isloggedInFeed: boolean;
  aemErrorMessages: any;
  isShoppingHeaderExist: boolean;
  medallionArrayFromContent: any;
  thankyouMessageMemberText: any;
  modalConfig = {
    animated: false,
    show: true
  };

  errorMessagesServiceSubscribe: Subscription;
  contentHeaderFooterServiceSubscribe: Subscription;
  flyoutFeedHeaderPosition: any;
  isFlyoutLoaded = false;
  loggedInModalLoaded = false;
  deviceTypeSubscribe: Subscription;
  feedTabLoggedinFlag = false;
  flyoutLoggedInObject: any;
  public resAcctSumDetails: any;
  public todayServiceData: any;
  logOutServiceSubscribe: Subscription;
  triggerNewsData = false;
  private unsubscribe: Subject<void> = new Subject();
  private innerSpan;
  private animationTime = '300ms';
  orionFlag = false;
  content: Tracker = TrackerCollapsedForStandardMocks;
  contentErrorMessage: ErrorMessage = {} as ErrorMessage;
  isLoggedIn = false;
  iropEnabled = false;
  iropLoaded = false;

  constructor(
    private _el: ElementRef,
    private changeDetection: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService,
    public bsModalRef: BsModalRef,
    private _renderer: Renderer2,
    private errorService: ErrorMessagesReducerStoreService,
    private cookieHelper: CookieHelper,
    @Inject(PLATFORM_ID) private platformId: Object,
    private srv: CommonService,
    private _builder: AnimationBuilder,
    private config: ApplicationConfig,
    private accountSummaryService: AccountSummaryService,
    private todayTripService: TripService,
    private logOutService: LogoutService,
    private datalayer: DataLayer,
    private userSession: UserSessionService,
    private loggingService: LoggingService,
    private userData: UserDataService,
    private el: ElementRef,
    private todaysTripAwsService: TodaysTripAwsService,
    protected renderer: Renderer2,
    public iropService: IropService
  ) {
    const storedNotificationFeedObj = JSON.parse(
      localStorage.getItem('feedNotificationObj')
    );
    this.feedCounterValue = storedNotificationFeedObj
      ? storedNotificationFeedObj.feedCounterValue
      : 0;
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    if (isPlatformBrowser(this.platformId) && document && document.body) {
      if (document.body.clientWidth <= 767) {
        this.isFlyoutLoaded = true;
        this.flyoutFeedHeaderPosition = -89;
      } else {
        this.isFlyoutLoaded = false;
      }
    }
    this.flyoutLoggedInObject = this.srv.flyoutPosition(
      'logged-in',
      this.isFlyoutLoaded
    );
    this.flyOutPositionHeight =
      this.flyoutLoggedInObject?.flyOutPositionHeight ?? 0;
    this.flyoutFeedHeaderPosition =
      this.flyoutLoggedInObject?.flyoutFeedHeaderPosition ?? 0;
    if (isPlatformBrowser(this.platformId)) {
      if (document.body.scrollWidth < 992 && document.body.scrollWidth > 767) {
        const modelContainer = document.getElementsByTagName('modal-container');
        if (modelContainer && modelContainer.length > 0) {
          modelContainer[0].classList.add('notification-loggedin-modal');
          this.loggedInModalLoaded = true;
        }
      }
      this.flyoutResizeScroll();
    }
  }

  flyoutResizeScroll() {
    const docHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    );
    const modalData = document.getElementsByTagName('modal-container');
    const topAlign = modalData[0].querySelector(
      'div.content-loggedIn.flyout-content.content'
    );
    if (docHeight && docHeight < 750 && modalData && modalData.length > 0) {
      // let scrollModalContainer = this._renderer.selectRootElement('modal-container');
      // this._renderer.addClass(scrollModalContainer, 'height-scroll');
      modalData[0].classList.add('height-scroll');
      if (topAlign !== null && topAlign !== undefined) {
        topAlign.setAttribute('style', 'top: 0');
      }
    } else {
      modalData[0].classList.remove('height-scroll');
      if (topAlign !== null && topAlign !== undefined) {
        topAlign.removeAttribute('style');
      }
      this.flyoutLoggedInObject = this.srv.flyoutPosition(
        'logged-in',
        this.isFlyoutLoaded
      );
      this.flyOutPositionHeight =
        this.flyoutLoggedInObject?.flyOutPositionHeight ?? 0;
      this.flyoutFeedHeaderPosition =
        this.flyoutLoggedInObject?.flyoutFeedHeaderPosition ??
        this.flyoutFeedHeaderPosition;
    }
  }

  checkForTodaysTripData(): boolean {
    return (
      !this.todayServiceData.trip ||
      !this.todayServiceData.trip.departureCityCode ||
      !this.todayServiceData.trip.arrivalCityCode
    );
  }

  updateFeedCount() {
    this.feedCounterValue = 0;
    const visitedTodayDate: Date = new Date();
    const feedNotificationsObj = {
      feedCounterValue: this.feedCounterValue,
      lastVisitedFeedAdvisories: visitedTodayDate
    };
    localStorage.setItem(
      'feedNotificationObj',
      JSON.stringify(feedNotificationsObj)
    );
    const el = document.getElementsByClassName('feed-counter')[0];
    if (el !== null && el !== undefined) {
      this._renderer.setStyle(el, 'display', 'none');
    }
  }

  closeloginFlyout() {
    if (this.bsModalRef && isPlatformBrowser(this.platformId)) {
      if (document.body.scrollWidth <= 768) {
        this.bsModalRef.hide();
      }
    }
  }

  flyoutPositionTabLandscape() {
    const clientHeight = document.documentElement.clientHeight;
    const flyoutContent = document.body.querySelector('.flyout-content');
    if (flyoutContent !== null && flyoutContent !== undefined) {
      this.flyOutPositionHeight = clientHeight - flyoutContent.clientHeight - 2;
    }
  }

  getLoginStatus(value: boolean) {
    this.isLoggedIn = value;
  }

  ngOnInit() {
    this.isloggedInFeed = true;
    this.showNewToday = this.config.get('APP_SHOW_NEW_FLYOUT') === 'true';
    const el = document.getElementsByClassName('toggle-flyout')[0];
    if (el !== null && el !== undefined) {
      el.className += ' toggle-up';
    }
    this.flyoutLoggedInObject = this.srv.flyoutPosition(
      'logged-in',
      this.isFlyoutLoaded
    );
    this.flyOutPositionHeight =
      this.flyoutLoggedInObject?.flyOutPositionHeight ?? 0;
    this.flyoutFeedHeaderPosition =
      this.flyoutLoggedInObject?.flyoutFeedHeaderPosition ??
      this.flyoutFeedHeaderPosition;
    this.flyoutResizeScroll();
    this.errorMessagesServiceSubscribe = this.errorService.errorMessages
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        if (data) {
          if (data.errorMessages) {
            this.aemErrorMessages = data.errorMessages;
          }
        }
      });
    this.contentHeaderFooterServiceSubscribe =
      this.contentService.contentHeaderFooter
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (data) => {
            if (data) {
              this.staticTrackerAemContent = data?.header?.trackerStaticText;
              if (this.staticTrackerAemContent) {
                const { trackerStaticText } = data.header;
                this.showStaticTracker =
                  trackerStaticText?.showStaticTracker === 'true'
                    ? true
                    : false;
                this.upcomingTracker =
                  trackerStaticText?.displayUpcomingTracker === 'true'
                    ? true
                    : false;
              }
              this.flyoutContent = data.header.auxiliaryNavigation.get(
                'myFlightPanel'
              )
                ? data.header.auxiliaryNavigation.get('myFlightPanel').details
                : null;
              this.flyoutTodayContent = data.header.auxiliaryNavigation.get(
                'todayPanel'
              )
                ? data.header.auxiliaryNavigation.get('todayPanel').details
                : null;
              if (
                this.flyoutContent !== null &&
                this.flyoutContent !== undefined
              ) {
                if (
                  this.flyoutContent.medallion !== null &&
                  this.flyoutContent.medallion !== undefined
                ) {
                  this.medallionArrayFromContent = this.flyoutContent.medallion;
                }
              }
              if (data.header.primaryNavigations) {
                this.mytripHeaderContentLabel =
                  data.header.primaryNavigations.get('my_trips').label;
                this.bookingHeaderContentLabel =
                  data.header.primaryNavigations.get('book').label;
              }
              this.setAcountOVerView();
              // if (this.isDelta) {
              if (this.userSession.getServiceWorkerCheck()) {
                this.accountSummaryServiceSubscribe = this.getAccountSummary();
              }
              // }
              this.checkForIrop();
              this.changeDetection.detectChanges();
            }
          },
          (err) => {
            this.loggingService.log('Caught Error: ' + err);
          }
        );
    this.updateFlyoutLabel();
  }

  checkForIrop() {
    this.iropServiceSubscribe = this.iropService.getContent().subscribe(
      (irop) => {
        this.iropEnabled = irop.iropType;
        this.postIropCheck();
      },
      () => {
        this.postIropCheck();
      }
    );
  }

  postIropCheck() {
    this.iropLoaded = true;
  }

  hideAllTabs() {
    requestAnimationFrame(() => {
      const tabElement = this._el.nativeElement.querySelector(
        '.loggedin-flyout.delta tabset.tab-container ul.nav.nav-tabs'
      ) as HTMLElement;
      if (tabElement && !this.enableTodayTab) {
        const mySkymilesTab = document.querySelector(
          '#mydelta-tab-link'
        ) as HTMLElement;
        if (mySkymilesTab) {
          mySkymilesTab.click();
        }
        tabElement.style.display = 'none';
      }
    });
  }

  loadCSS() {
    const link = this.renderer.createElement('link');
    this.renderer.setAttribute(link, 'rel', 'stylesheet');
    this.renderer.setAttribute(
      link,
      'href',
      this.config.get('APP_AURA_CSS_URL')
    );
    this.renderer.setAttribute(link, 'data-css-include', 'true');
    this.renderer.appendChild(this.el.nativeElement, link);
  }

  getAccountSummary() {
    return forkJoin([
      this.accountSummaryService.getAccountSummaryDetails(),
      this.userData.getAuthConfigContent()
    ])
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        ([resAcc, authConfig]) => {
          // const resAcc = this.accountSummaryService.getDummyLogin();
          this.resAcctSumDetails = resAcc;
          if (
            this.resAcctSumDetails !== null &&
            this.resAcctSumDetails !== undefined
          ) {
            //TODO: app name can be from config too for dynamic referencing
            if (
              this.config.get('APP') === 'homepage' ||
              this.config.get('APP') === 'shopping-slice' ||
              this.config.get('APP') === 'reshop-slice'
            ) {
              this.loadCSS();
            }
            this.resAcctSumContent = this.flyoutContent;
            this.member = this.resAcctSumDetails.medallionMemberDesc;
            this.greetingMessage = this.getWelcomeMessage();
            if (!this.isDelta) {
              this.memberTypeData = this.member
                ? this.member.replace('member', '')
                : this.member;
            }

            if (this.resAcctSumDetails.smNumber) {
              this.getLoginStatus(true);
            }
            if (!this.iropEnabled) {
              this.todayServiceData = authConfig.TRIPS_API_AWS
                ? this.todaysTripAwsService
                    .getTodayTrip(this.resAcctSumDetails.smNumber)
                    .pipe(takeUntil(this.unsubscribe))
                    .subscribe(
                      (resToday) => this.processTodaysTripData(resToday),
                      (err) => {
                        this.loggingService.log('Caught Error: ' + err);
                      }
                    )
                : this.todayTripService
                    .getTripDetailsDetails(this.resAcctSumDetails.smNumber)
                    .pipe(takeUntil(this.unsubscribe))
                    .subscribe(
                      (resToday) => this.processTodaysTripData(resToday),
                      (err) => {
                        this.loggingService.log('Caught Error: ' + err);
                      }
                    );
            }
          }
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
  }

  processTodaysTripData(resToday: TodaysTrip) {
    this.todayServiceData = resToday;
    const todayServiceDetails = this.todayServiceData;
    if (this.checkForTodaysTripData()) {
      this.enableTodayTab = false;
      this.hideAllTabs();
      if (this.todayServiceData.iropImpact) {
        this.iropEnable = this.todayServiceData.iropImpact;
      }
      if (this.enableTodayTab === false) {
        const tabRolechange = this._el.nativeElement.querySelectorAll(
          '.loggedin-flyout ul li'
        );
        if (tabRolechange?.length > 0) {
          for (let i = 0; i < tabRolechange.length; i++) {
            if (tabRolechange[i].children[0].id === 'mydelta-tab-link') {
              tabRolechange[i].setAttribute('style', 'width: 50%');
            }
            if (tabRolechange[i].children[0].id === 'feed-tab-link') {
              tabRolechange[i].setAttribute('style', 'width: 50%');
              const feedCounter = this._el.nativeElement.querySelector(
                '.flyout-feed-counter'
              );
              if (feedCounter) {
                feedCounter.setAttribute('style', 'left: 5.875rem');
              }
            }
          }
        }
      }
    } else if (todayServiceDetails?.trip?.daysToNextFlightDeparture === null) {
      this.enableVsTodayTab = true;
    }
    this.datalayer.setDdcfbData(this.resAcctSumDetails);
    this.changeDetection.detectChanges();
  }

  updateFlyoutLabel() {
    const ftwrCookieValue = this.cookieHelper.getCookieValue('ftwr-myprofile');
    if (
      ftwrCookieValue &&
      (ftwrCookieValue === '/myprofile' || ftwrCookieValue === '%2Fmyprofile')
    ) {
      if (
        this.flyoutContent?.dashboardLabel &&
        this.flyoutContent?.dashboardUrl
      ) {
        const mytripsLabel = 'My Trips'; // TODO: (Surya) will remove this once the 100% profile is turned on . This is just a temporary fix unil August release.
        this.flyoutContent.dashboardLabel = mytripsLabel;
        this.flyoutContent.dashboardUrl = this.config.get('APP_MYTRIPS_URL')
          ? this.config.get('APP_MYTRIPS_URL')
          : '/mytrips/';
      }
    }
  }

  getWelcomeMessage() {
    const date = new Date();
    const hrs = date.getHours();
    let welcomeMessage: string;
    if (this.resAcctSumContent) {
      if (this.isDelta && this.resAcctSumContent?.salutation?.length > 2) {
        if (hrs < 12) {
          welcomeMessage = this.resAcctSumContent.salutation[0].salutationLabel;
        } else if (hrs >= 12 && hrs <= 17) {
          welcomeMessage = this.resAcctSumContent.salutation[1].salutationLabel;
        } else if (hrs >= 17 && hrs <= 24) {
          welcomeMessage = this.resAcctSumContent.salutation[2].salutationLabel;
        }
      } else if (
        !this.isDelta &&
        this.resAcctSumContent?.salutation?.length > 2
      ) {
        welcomeMessage = this.resAcctSumContent.salutation[3].salutationLabel;
      }
    }
    return welcomeMessage;
  }

  setAcountOVerView() {
    if (this.flyoutContent.isDelta) {
      this.isDelta = this.flyoutContent.isDelta.toUpperCase() === 'TRUE';
    } else {
      this.isDelta = true;
    }
  }

  getClassNamesVS(medFlag: string) {
    if (!this.resAcctSumDetails) {
      return { 'va-tier-color-ff': true };
    }
    const flags = {
      FF: 'va-tier-color-ff',
      FO: 'va-tier-color-sm',
      GM: 'va-tier-color-gm'
    };
    const bgClassName = flags[medFlag] ?? 'va-tier-color-ff';

    return { [bgClassName]: true };
  }

  getClassNamesDelta(medFlag: string) {
    const classList = {
      GM: {
        'account-summary': true,
        'account-summary-gm': true
      },
      DM: {
        'account-summary': true,
        'account-summary-dm': true
      },
      PM: {
        'account-summary': true,
        'account-summary-pm': true
      },
      FF: {
        'account-summary': true,
        'account-summary-ff ': true
      },
      FO: {
        'account-summary': true,
        'account-summary-sm': true
      }
      /* GM: {
        'account-summary': true,
        'account-summary-vsgm': true
      } */
    };
    const bgClassNames = classList[medFlag] ?? {
      'account-summary': true,
      'account-summary-sky-mem': true
    };
    return bgClassNames;
  }

  selectedTabEvent(event: any, name) {
    this.triggerNewsData = event && event === 'feed-tab';
    if (event.id !== undefined && event.id !== null) {
      if (event.id === 'feed-tab') {
        this.feedTabLoggedinFlag = true;
      } else if (event.id === 'feed-tab-link') {
        this.triggerNewsData = true;
      } else {
        this.feedTabLoggedinFlag = false;
        this.triggerNewsData = false;
      }
      this.timeouts.push(
        setTimeout(() => {
          const focusTabFocus =
            this._el.nativeElement.querySelector('.tab-container').children[1];
          // focusTabFocus.setAttribute('tabindex', '1');
          // focusTabFocus.focus();
          const selectedTabFocus = this._el.nativeElement
            .querySelector('.tab-container')
            .children[0].querySelector('a.active');
          // selectedTabFocus.focus();
          // selectedTabFocus.setAttribute('aria-selected', 'true');
        }, 300)
      );

      const todayTabContent = this._el.nativeElement.querySelectorAll(
        'tabset.tab-container'
      );
      const tabContent = this._el.nativeElement.querySelector(
        '.tab-content'
      ) as HTMLElement;
      if (
        event.id === 'today-tab' &&
        todayTabContent !== undefined &&
        todayTabContent.length > 0
      ) {
        this._renderer.addClass(todayTabContent[0], 'today-tab-align');
        if (tabContent) {
          tabContent.style.paddingTop = '10px';
        }
      } else if (todayTabContent !== undefined && todayTabContent.length > 0) {
        this._renderer.removeClass(todayTabContent[0], 'today-tab-align');
        if (tabContent) {
          tabContent.style.paddingTop = '10px';
        }
      }

      if (
        event.id === 'mydelta-tab' &&
        todayTabContent !== undefined &&
        todayTabContent.length > 0
      ) {
        if (tabContent) {
          tabContent.style.margin = '0';
          tabContent.style.paddingTop = '0';
        }
      }

      const feedTabContent =
        this._el.nativeElement.querySelectorAll('div.tab-content');
      if (
        event.id !== undefined &&
        event.id === 'feed-tab' &&
        feedTabContent !== undefined &&
        feedTabContent.length > 0
      ) {
        this._renderer.addClass(feedTabContent[0], 'notify-tab-align');
      } else if (feedTabContent !== undefined && feedTabContent.length > 0) {
        this._renderer.removeClass(feedTabContent[0], 'notify-tab-align');
      }
    }
  }

  afterViewHelper() {
    if (this.isDelta) {
      const activeModalElement = this._el.nativeElement;
      this.axHandler(activeModalElement);
      this.removeAria();
      const linkRolechange = this._el.nativeElement.querySelectorAll(
        '.feed-advisories ul li'
      );
      if (linkRolechange?.length > 0) {
        for (let i = 0; i < linkRolechange.length; i++) {
          this._renderer?.removeAttribute(
            linkRolechange[i]?.children[0],
            'role'
          );
        }
      }
      if (
        this._el?.nativeElement?.querySelector(
          '.loggedin-flyout .feed-tab-link a'
        )
      ) {
        this._renderer.setAttribute(
          this._el?.nativeElement?.querySelector(
            '.loggedin-flyout .feed-tab-link a'
          ),
          'aria-controls',
          'feed-tab'
        );
      }

      if (
        this._el?.nativeElement?.querySelector(
          '.loggedin-flyout .mydelta-tab-link a'
        )
      ) {
        this._renderer.setAttribute(
          this._el?.nativeElement?.querySelector(
            '.loggedin-flyout .mydelta-tab-link a'
          ),
          'aria-controls',
          'mydelta-tab'
        );
      }

      if (
        this._el?.nativeElement?.querySelector(
          '.loggedin-flyout .today-tab-link a'
        )
      ) {
        this._renderer.setAttribute(
          this._el?.nativeElement?.querySelector(
            '.loggedin-flyout .today-tab-link a'
          ),
          'aria-controls',
          'today-tab'
        );
      }

      // this._renderer.setAttribute(this._el.nativeElement.querySelector('.loggedin-flyout .feed-tab-link a'), 'aria-hidden', 'true');
    }
    const modalElement = document.getElementsByTagName('modal-container');
    if (modalElement && modalElement.length > 0) {
      modalElement[0].addEventListener(
        'click',
        this.backDropClickHandler.bind(this)
      );
      modalElement[0].setAttribute('aria-labelledby', 'feed');
    }
  }

  removeBottomPadding() {
    const element = this._el.nativeElement.querySelector(
      '.fresh-air .loggedin-flyout.delta tabset.tab-container .tab-content'
    ) as HTMLElement;
    if (element) {
      element.style.paddingBottom = '0';
    }
  }

  orionErrorMessageStyles() {
    if (isPlatformBrowser(this.platformId)) {
      const error = this._el.nativeElement.querySelector(
        '.single-error-message'
      ) as HTMLElement;
      const modal = this._el.nativeElement.querySelector(
        '.modal-body'
      ) as HTMLElement;

      if (error && modal) {
        modal.style.minHeight = '37.8125rem';
      }
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      // this._renderer.setAttribute(this._el.nativeElement.querySelector('.loggedin-flyout .mydelta-tab-link a'), 'aria-hidden', 'true');
      // this._renderer.setAttribute(this._el.nativeElement.querySelector('.loggedin-flyout .today-tab-link a'), 'aria-hidden', 'true');
      this.userData.getAuthConfigContent().subscribe((response) => {
        if (response && response['ORION_FLYOUT'] === true) {
          this.orionFlag = true;
          this.removeBottomPadding();
          this.afterViewHelper();
        } else {
          this.afterViewHelper();
        }
      });
    }
    setTimeout(() => {
      this.orionErrorMessageStyles();
      this.srv.trapFocusInsideModal(this._el);
      let tabRolechange = this._el.nativeElement.querySelectorAll(
        '.loggedin-flyout ul li.nav-item'
      );
      const myDeltaTab = this._el.nativeElement.querySelector('#mydelta-tab');
      const feedTab = this._el.nativeElement.querySelector('#feed-tab');
      if (tabRolechange && tabRolechange.length > 0) {
        let isFeedtab = true;
        tabRolechange = Array.prototype.slice.call(tabRolechange);
        tabRolechange.forEach((item) => {
          if (
            item.children[0].id === 'mydelta-tab-link' &&
            item.children[0].classList.contains('active')
          ) {
            this._renderer.setAttribute(
              item.children[0],
              'aria-selected',
              'true'
            );
            this._renderer.setAttribute(item.children[0], 'tabindex', '0');
            isFeedtab = false;
            if (myDeltaTab) {
              this._renderer.setAttribute(myDeltaTab, 'tabindex', '0');
            }
          } else if (item.children[0].id === 'feed-tab-link' && isFeedtab) {
            this._renderer.setAttribute(
              item.children[0],
              'aria-selected',
              'true'
            );
            this._renderer.setAttribute(item.children[0], 'tabindex', '0');
            if (feedTab) {
              this._renderer.setAttribute(feedTab, 'tabindex', '0');
            }
          }
        });
      }
    }, 500);
  }

  handlekeydown(e) {
    const liElement = this._el.nativeElement.querySelectorAll(
      '.loggedin-flyout ul li.nav-item'
    );
    if (e.keyCode === 37 || e.keyCode === 40) {
      // down and left arrow
      const newParentelm = e.target.parentElement.previousElementSibling;
      if (newParentelm) {
        this.navTabkeydoenhandler(newParentelm);
      } else if (liElement) {
        this.navTabkeydoenhandler(liElement[liElement.length - 1]);
      }
    } else if (e.keyCode === 38 || e.keyCode === 39) {
      // up & right arrow
      const newParentelm = e.target.parentElement.nextElementSibling;
      if (newParentelm) {
        this.navTabkeydoenhandler(newParentelm);
      } else if (liElement) {
        this.navTabkeydoenhandler(liElement[0]);
      }
    }
  }

  navTabkeydoenhandler(newParentelm) {
    if (newParentelm !== null && newParentelm !== undefined) {
      this.removeAria();
      const newElm = newParentelm.children[0];
      newElm.click();
      newElm.setAttribute('tabindex', '0');
      newElm.setAttribute('aria-selected', 'true');
      newElm.focus();
      const tabElmid = newElm.getAttribute('aria-controls');
      const tabElmt = this._el.nativeElement.querySelector('#' + tabElmid);
      if (tabElmt) {
        tabElmt.setAttribute('tabindex', '0');
      }
    }
  }

  removeAria() {
    let liElement = this._el.nativeElement.querySelectorAll(
      '.loggedin-flyout ul li.nav-item'
    );
    let tabElement = this._el.nativeElement.querySelectorAll(
      '.loggedin-flyout .tab-content tab'
    );
    const ulElm = this._el.nativeElement.querySelector(
      '.loggedin-flyout ul.nav.nav-tabs'
    );
    const divtab = this._el.nativeElement.querySelector(
      '.loggedin-flyout .tab-content'
    );
    if (ulElm) {
      this._renderer.setAttribute(ulElm, 'role', 'none');
    }
    if (divtab) {
      this._renderer.setAttribute(divtab, 'tabindex', '-1');
    }
    if (liElement) {
      liElement = Array.prototype.slice.call(liElement);
      liElement.forEach((item) => {
        this._renderer.setAttribute(item.children[0], 'aria-selected', 'false');
        this._renderer.setAttribute(item.children[0], 'tabindex', '-1');
        this._renderer.setAttribute(item.children[0], 'role', 'tab');
        this._renderer.setAttribute(item, 'role', 'none');
        item.children[0].addEventListener(
          'keydown',
          this.handlekeydown.bind(this)
        );
      });
    }
    if (tabElement) {
      tabElement = Array.prototype.slice.call(tabElement);
      tabElement.forEach((item) => {
        this._renderer.setAttribute(item, 'tabindex', '-1');
      });
    }
  }

  axHandler(activeModalElement) {
    const focusableLinks = this._el.nativeElement.querySelectorAll(
      '.nav-item .nav-link, .bottom-sticky-links a'
    );
    const len = focusableLinks.length;
    const tabbableElsfirst = focusableLinks[0];
    const lastElemFocus = focusableLinks[len - 1];
    activeModalElement.addEventListener('keydown', (e: any) => {
      if (e.keyCode === 9 && !(e.shiftKey && e.keyCode === 9)) {
        if (document.activeElement === lastElemFocus) {
          tabbableElsfirst.focus();
          e.preventDefault();
        }
      }
      if (e.keyCode === 9 && e.shiftKey && e.keyCode === 9) {
        if (document.activeElement === tabbableElsfirst) {
          lastElemFocus.focus();
          e.preventDefault();
        }
      }
    });
  }

  backDropClickHandler(event) {
    const flyout = event.target.parentElement;
    if (flyout) {
      const isModalContainerClicked =
        event.target.classList.contains('notification-loggedin-modal') ||
        flyout.classList.contains('modal-content');
      if (this.loggedInModalLoaded && isModalContainerClicked) {
        const el = this._el.nativeElement.querySelector('.toggle-up');
        if (el !== null && el !== undefined) {
          el.className = 'toggle-flyout';
          el.querySelector('img').setAttribute('alt', 'Collapsed');
        }
        this.bsModalRef.hide();
        this.loggedInModalLoaded = false;
      }
    }
  }

  generateSpan(text) {
    const s = this._renderer.createElement('span');
    this._renderer.setAttribute(s, 'class', 'sr-only');
    if (text !== null) {
      const stext = this._renderer.createText(text);
      this._renderer.appendChild(s, stext);
    }
    return s;
  }

  focusActiveTab() {
    this._el.nativeElement.querySelector('.loggedin-modal').focus();
  }

  setModalHeight() {
    if (
      this._el.nativeElement.querySelector('.loggedin-flyout')?.offsetParent
    ) {
      if (this.config.get('APP_DISABLE_LEGACY') === 'false') {
        const parentContainer = this._el.nativeElement;
        parentContainer.className += ' loggedIn-modal-height';
      } else {
        const parentContainer =
          this._el.nativeElement.querySelector('.loggedin-flyout').offsetParent
            .children[0];
        parentContainer.className += ' loggedIn-modal-height';
      }
    }
  }

  close() {
    if (this.bsModalRef && isPlatformBrowser(this.platformId)) {
      if (document.body.scrollWidth < 992) {
        const feedHeaders = document.getElementsByClassName('feed-header');
        if (feedHeaders !== undefined && feedHeaders !== null) {
          for (let i = 0; i < feedHeaders.length; i++) {
            if (
              !feedHeaders[i].classList.contains('notification-feed-header')
            ) {
              feedHeaders[i].classList.remove('feed-header-fixed');
              feedHeaders[i].setAttribute(
                'style',
                'top :' + this.flyoutFeedHeaderPosition + 'px'
              );
            } else {
              feedHeaders[i].classList.add('notification-feed-header-hide');
            }
          }
        }
        if (this.isDelta) {
          const el = document.getElementsByClassName('flyout-loggedin-feed')[0];
          if (el) {
            el.classList.add('loggedIn-feed-flyout-absolute');
          }
        }
        const logoutContainer =
          document.getElementsByClassName('logoutdivContainer')[0];
        if (logoutContainer) {
          logoutContainer.classList.add('logoutdivContainer-animate');
        }
        const el = this._el.nativeElement.querySelector('.toggle-up');
        if (el !== null && el !== undefined) {
          el.className = 'toggle-flyout';
          el.querySelector('img').setAttribute('alt', 'Collapsed');
        }
        this.bsModalRef.hide();
      } else {
        const el = this._el.nativeElement.querySelector('.toggle-up');
        if (el !== null && el !== undefined) {
          el.className = 'toggle-flyout';
          el.querySelector('img').setAttribute('alt', 'Collapsed');
        }
        this.bsModalRef.hide();
      }
    }
  }

  stopTimeout() {
    for (let i = 0; i < this.timeouts.length; i++) {
      clearTimeout(this.timeouts[i]);
    }
    this.timeouts = [];
  }

  logOut() {
    if (isPlatformBrowser(this.platformId) && document) {
      let logoutUrl = '';
      if (
        this.config.get('APP_LOGOUT_URL_FROM_PROPERTY') === 'true' &&
        this.config.get('APP_NEW_LOGOUT_URL') !== undefined
      ) {
        logoutUrl = this.config.get('APP_NEW_LOGOUT_URL');
      } else {
        logoutUrl = this.flyoutContent.logoutUrl;
      }
      this.logOutServiceSubscribe = this.logOutService
        .logOutAction(logoutUrl)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res) => {
            // window.location.href = this.urlUtil.hostUrl; // document.location.origin + this.urlUtil.hostUrl;
            // window.location.replace(this.urlUtil.hostUrl);
            this.srv.removeSessionStorageAfterLogout();
            this.logOutService.pingLogOut();
          },
          (err) => {
            window.location.replace('/');
            this.loggingService.log('Caught Error: ' + err);
          }
        );
    }
  }

  ngOnDestroy() {
    if (this.errorMessagesServiceSubscribe) {
      this.errorMessagesServiceSubscribe.unsubscribe();
    }
    if (this.iropServiceSubscribe) {
      this.iropServiceSubscribe.unsubscribe();
    }
    if (this.contentHeaderFooterServiceSubscribe) {
      this.contentHeaderFooterServiceSubscribe.unsubscribe();
    }
    if (this.accountSummaryServiceSubscribe) {
      // Loadtest ObsUnsub added
      this.accountSummaryServiceSubscribe.unsubscribe();
    }
    if (this.logOutServiceSubscribe) {
      this.logOutServiceSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.stopTimeout();
    if (this.deviceTypeSubscribe) {
      this.deviceTypeSubscribe.unsubscribe();
    }
  }
}
